<template>
  <div v-if="showPaymentCard" id="payment-info" class="cell" :class="s2ap ? 'large-4' : 'large-6'">
    <h2 class="h5 margin-bottom-xs">
      {{ paymentInfoText }}
    </h2>
    <div>
      <PaymentRow :label="subtotalText" :value="subTotal" />
      <PaymentRow id="door-dash-shipping" :label="doorDashShippingText" :value="doorDashShipping" />
      <div v-if="shippingMethod?.shippingMethod" id="shipping-method" class="grid-x align-justify margin-bottom-xxs">
        {{ shippingMethod?.shippingMethod }}
        <div v-if="shippingMethod?.shippingFee" id="shipping-fee">
          {{ shippingMethod?.shippingFee }}
        </div>
      </div>
      <PaymentRow v-if="protectionPlanTotal" :label="protectionPlanLabel" :value="protectionPlanTotal" />
      <PaymentRow v-for="(row, index) in paymentRows" :key="row.id || index" v-bind="row" />
      <button v-if="showViewAllTransactionsBtn" name="view-all-transactions-button" @click="emit('triggerSlideout')">
        <span class="link-body">{{ viewAllTransactionsText }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ORDER_DETAILS } from 'config';
import PaymentRow from './PaymentRow.vue';

const props = defineProps({
  payment: {
    type: Object,
    default: () => {},
  },
  showViewAllTransactionsBtn: {
    type: Boolean,
    default: true,
  },
  s2ap: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['triggerSlideout']);
const paymentInfo = computed(() => props.payment || {});
const paymentRows = computed(() => [
  { id: 'gift-wrap-fee', label: giftWrapFeeText, value: giftWrapFee },
  { id: 'e-waste-fee', label: eWasteRecyclingFeeText, value: eWasteFee },
  { id: 'battery-fee', label: batteryFeeLabel, value: batteryFee },
  { id: 'return-fee', label: returnLabelFeeText, value: returnLabelFee },
  { id: 'other-fee', label: otherFeesText, value: otherFee },
  { id: 'total-fee', label: totalFeesText, value: totalFee },
  { label: taxText, value: tax },
  { label: totalText, value: total, heavy: true },
]);
const {
  subTotal,
  protectionPlanTotal,
  doorDashShipping,
  giftWrapFee,
  eWasteFee,
  shippingMethod,
  batteryFee,
  batteryFeeLabel,
  returnLabelFee,
  otherFee,
  totalFee,
  tax,
  total,
} = paymentInfo.value;
const showPaymentCard = computed(() => Object.keys(props.payment || {}).length > 0);
const {
  paymentInfoText,
  subtotalText,
  doorDashShippingText,
  giftWrapFeeText,
  eWasteRecyclingFeeText,
  otherFeesText,
  totalFeesText,
  taxText,
  totalText,
  viewAllTransactionsText,
  protectionPlanLabel,
  returnLabelFeeText,
} = ORDER_DETAILS.paymentInformation;
</script>
